import { useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import { DataItem } from 'src/types/DataItem';

import { Button } from 'src/components/basicContent/_Button/Button';

import ChevronDownIconSvg from 'public/icons/ChevronDown.svg';

import styles from './_SortByFilter.module.css';

type SortByFilterProps = {
	defaultSortOption?: number;
	label: Field<string>;
	inputData: DataItem[];
};

export function SortByFilter(props: SortByFilterProps): JSX.Element {
	const { setValue, watch } = useFormContext();
	const selectedValue = watch('SortOption');
	const headBtn = useRef<HTMLButtonElement>(null);
	const selectedValues = !Array.isArray(selectedValue) ? [selectedValue] : selectedValue;

	const [active, setActive] = useState(false);

	const selectedInputData = () => {
		return props.inputData
			.filter((x) => selectedValues.includes(x.value))
			.map((x) => x.label)
			.join(', ');
	};

	const activeClass = active ? styles.active : '';

	return (
		<div className={styles.sortByFilterContainer + ' padX'}>
			<Text tag="label" field={props.label} className={styles.sortByLabel} />
			<div className={`${styles.root} ${activeClass}`}>
				<Button
					title="selectSort"
					buttonRef={headBtn}
					className={`${styles.head} underline ${activeClass}`}
					onClick={(e) => {
						if (e?.nativeEvent.target === headBtn.current) {
							setActive(!active);
						}
					}}
					onBlur={() => {
						setTimeout(() => {
							setActive(false);
						}, 100);
					}}
				>
					<>{selectedInputData()}</>
					<ChevronDownIconSvg className={`${styles.icon} ${activeClass}`} />
				</Button>

				<div className={`${styles.sortByFilterBody} ${activeClass}`}>
					<div className={styles.list}>
						{props.inputData.map((item, index) => {
							return (
								<Button
									key={`${styles.root}-${index}`}
									title="selectSortOption"
									className={`${selectedValues.some((x) => x === item.value) ? styles.selected : ''} buttonReset`}
									onClick={() => {
										setValue('SortOption', item.value);
										setActive(false);
									}}
								>
									<>
										<span className={styles.checked} />
										{item.label}
									</>
								</Button>
							);
						})}
					</div>
				</div>
			</div>
		</div>
	);
}
